import axios from "axios";

export const state = {
    countries: [],
};

export const getters = {
    countries: state => state.countries,
};

export const mutations = {
    setCountries(state, newValue) {
        state.countries = newValue
    },
};

export const actions = {
    async fetchCountries({ commit }) {
        await axios.get('/countries').then(res => {
            commit('setCountries', res.data.countries);
        })
    },
};
